import { PageHeader, Loading } from "@/components/Common";
import { useLoad } from "@/hooks/useData";
import { api } from "@/lib/api";

const when = (ts) => new Date(ts).toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", timeZone: "Asia/Kolkata" });

export default function ShipmentActivity() {
  const { data } = useLoad(() => api.get("/shipments/activity").then((r) => r.data));
  if (!data) return <Loading />;
  return (
    <div className="max-w-5xl">
      <PageHeader title="Activity log" subtitle="Every upload and sync with time, user, source and result." />
      <div className="panel overflow-auto">
        <table className="data-table" data-testid="activity-table">
          <thead><tr><th>When</th><th>User</th><th>Source</th><th>Result</th></tr></thead>
          <tbody>
            {data.map((a, i) => (
              <tr key={`${a.when}|${a.source}`} data-testid={`activity-row-${i}`}><td className="text-xs">{when(a.when)}</td><td className="text-sm">{a.user}</td>
                <td className="max-w-[280px] truncate text-sm" title={a.source}>{a.source}</td><td className="whitespace-normal text-sm">{a.result}</td></tr>
            ))}
          </tbody>
        </table>
        {!data.length && <div className="py-10 text-center text-sm text-muted-foreground">No activity yet.</div>}
      </div>
    </div>
  );
}
